import { AuthService } from 'src/app/Service/AuthService';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BasePopoverContentsComponent } from 'src/app/View/BaseUI/BasePopoverContentsComponent';


/**
 * PopoverChangeCounselComponent
 * 面談回答の変更ポップアップ画面

	 // 呼び出し方：
		// BaseViewの表示メソッドを呼ぶ。
		// 第1引数： 中身のコンポーネントクラス
		// 第2引数： 中身に渡すデータ。
		this.showDialogWindow(
			PopoverChangeCounselComponent,
			{
				title: '警告',
				text: '削除してもよろしいですか？',
				close: this.confirmReceive.bind(this)
			 }
		);

	// 中身に渡すデータ構造：
	{
		title: '確認',							// タイトル用 文字列	HTML側にバインディングで使用
		text: '登録してよろしいですか？',		// 本文					HTML側にバインディングで使用
		close: this.confirmReceive.bind(this)	// 終了メソッドが入る。現在は、これで結果受け取る構造。
	 }

	close用メソッドは、下記の引数で用意する。
	confirmReceive(ret: boolean)

*/
@Component({
	selector: 'popover-confirm-component',
	templateUrl: './ForgetPasswordPopupComponent.html',
	styleUrls: ['./ForgetPasswordPopupComponent.scss'],
})
export class ForgetPasswordPopupComponent extends BasePopoverContentsComponent {

	// 入力が無いときに表示するアラート文言のフラグ
	public showAlertNoInput = false;

	// 送信するデータ
	public formData = {
		mail: '',
		birthday: ''
	};

	/**
	 * constructor
	 */
	constructor(
			public dialogRef: MatDialogRef<ForgetPasswordPopupComponent>, //自分の参照。これにcloseしてもいい
			@Inject(MAT_DIALOG_DATA) public data: any, // 呼び出し側から受け取るデータ
	) {
		// Angularのコンポーネントなので上位を呼ぶ。
		super();

	}

	/**
	 * start
	 * 開始処理
	 */
	public start() {

	}


	/**
	 * sendForgetPasswordURL
	 * パスワード忘れメールを送信。
	 * 送信後にポップアップは閉じる
	 */
	public async sendForgetPasswordURL() {

		// APIを叩いてメアド送信
		// 閉じた後に送信しましたポップアップ出すので、別イベントを設定する
		// メールは投げっぱなしなので、特にエラー処理を行わない。
		const svc = new AuthService(this);
		if (this.formData.mail.length > 0 && this.formData.birthday.length > 0) {
			this.showAlertNoInput = false;
			await svc.sendForgetPassword(this.formData.mail, this.formData.birthday);
			this.data.success();
		} else {
			this.showAlertNoInput = true;
		}

	}

	/**
	 * onClickCansel
	 * キャンセルクリック
	 */
	public onClickCansel(){
		this.data.close();
	}

}
